import {
  ROUTE_MERGE_COMPANIES,
  ROUTE_PARAM_MERGE_COMPANIES_USER_ID_KEEP,
} from "@/constants/routes.constants";
import { Button } from "@/shadcn/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shadcn/components/ui/dialog";
import React from "react";
import { useNavigate } from "react-router";

type UserMergeDialogProps = {
  userID: string;
  onClose: () => void;
};

const UserMergeDialog: React.FC<UserMergeDialogProps> = ({
  userID,
  onClose,
}) => {
  const nav = useNavigate();

  function goToMergeCompaniesPage() {
    console.log("Navigating to merge companies page with userID:", userID);
    nav(
      `${ROUTE_MERGE_COMPANIES}?${ROUTE_PARAM_MERGE_COMPANIES_USER_ID_KEEP}=${userID}`
    );
    onClose();
  }

  return (
    <Dialog
      open={true}
      onOpenChange={(open) => {
        if (!open) {
          setTimeout(() => {
            onClose(); // call onClose when dialog is closed
          }, 100); // reset state after dialog closes
        }
      }}
    >
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Merge Companies</DialogTitle>
          <DialogDescription></DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <p>Would you like to merge this user's companies?</p>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button className="" onClick={goToMergeCompaniesPage}>
            View Merge Companies
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UserMergeDialog;
